import { type HttpClient } from '../useHttpClient';

export interface SetUnitInsightsBody {
  richContent: {
    version: 1;
    content: string | undefined;
  };
  status: 'DRAFT' | 'PUBLISHED';
  //   Pass this if the llm insight is the same as the one in the textArea
  contentFromLlmInsightId?: number;
}

interface SetUnitInsightsResponse {
  id: number;
  createdOn: string;
  publishedOn: string | null;
  publishedById: number | null;
  content: string | null;
  contentVersion: number | null;
  contentLanguage: string | null;
  contentByUserId: number | null;
}

export const postUnitInsights =
  (httpClient: HttpClient) =>
  async ({ unitId, body }: { unitId: number; body: SetUnitInsightsBody }) => {
    const response = await httpClient.api(
      `/admin/kpis/unit/${unitId}/insights`,
      {
        method: 'POST',
        body: JSON.stringify(body),
      }
    );

    return response.json as SetUnitInsightsResponse;
  };

export const putUnitInsights =
  (httpClient: HttpClient) =>
  async ({
    insightId,
    unitId,
    body,
  }: {
    insightId: number;
    unitId: number;
    body: SetUnitInsightsBody;
  }) => {
    const response = await httpClient.api(
      `/admin/kpis/unit/${unitId}/insights/${insightId}`,
      {
        method: 'PUT',
        body: JSON.stringify(body),
      }
    );

    return response.json as SetUnitInsightsResponse;
  };
